import { WizardBackground } from "@/components/mentor-profile/wizard-background";
import type { MentorProfileChangeRequest } from "@/lib/api/mentor-profile";
import { PostHogEvents, useTrackPage } from "@/lib/posthog-events";
import { Button } from "@somethings-ui/web";

interface RevisionFeedbackPopupProps {
  requests: MentorProfileChangeRequest[];
  mentorId: string;
  reviewRound: number;
  onDismiss: () => void;
}

export function RevisionFeedbackPopup({
  requests,
  mentorId,
  reviewRound,
  onDismiss,
}: RevisionFeedbackPopupProps) {
  useTrackPage(PostHogEvents.MENTOR_PROFILE_REVISION_FEEDBACK_POPUP_VIEWED, {
    mentor_id: mentorId,
    review_round: reviewRound,
  });

  return (
    <WizardBackground className="items-center justify-center">
      <div className="relative z-10 w-full max-w-lg rounded-2xl border border-surfaces-z5 bg-surfaces-z0 p-8 shadow-[0px_8px_48px_0px_rgba(0,0,0,0.15)]">
        <p className="font-body text-xs font-semibold uppercase tracking-[0.3px] text-brand-tangelo">
          Changes requested
        </p>
        <h1 className="mt-2 font-heading text-[28px] font-bold leading-[1.1] tracking-[-0.56px] text-text-primary">
          A few tweaks before we can publish
        </h1>
        <p className="mt-3 font-body text-[15px] leading-relaxed text-text-secondary">
          Your reviewer left notes on the sections below. Update those, then
          resubmit — everything else can stay as-is.
        </p>

        <ul className="mt-6 space-y-3">
          {requests.map((request) => (
            <li
              key={`${request.section}-${request.created_at}`}
              className="rounded-lg border border-brand-tangelo/30 bg-[#fff8f4] px-4 py-3"
            >
              <p className="font-body text-sm font-semibold capitalize text-text-primary">
                {request.section.replaceAll("_", " ")}
              </p>
              <p className="mt-1 font-body text-sm leading-relaxed text-text-secondary">
                {request.note}
              </p>
            </li>
          ))}
        </ul>

        <Button className="mt-8 w-full" onPress={onDismiss}>
          Review &amp; update
        </Button>
      </div>
    </WizardBackground>
  );
}
